import ReactDOM from "react-dom";

const LoadingPortal = ({ children }: any) => {
    const loadingRoot = document.getElementById("loading-root");
    return loadingRoot && ReactDOM.createPortal(children, loadingRoot);
};

export default LoadingPortal;
